/**
 * Created by Ning Jiang on 2024-01-19.
 */

import {DeadwoodRipSymbol} from "./DeadwoodRipSymbol";
import {DeadwoodRipSymbolState} from "./DeadwoodRipSymbolConfig";
import {TimelineLite} from "gsap";
import {IS1} from "./IS1";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";
import {DeadwoodRip} from "../DeadwoodRip";
import {DeadwoodRipReelView} from "../reels/DeadwoodRipReelView";
import {DeadwoodRipLayers, Layers} from "../view/DeadwoodRipLayers";
import {DeadwoodRipBackground} from "../view/DeadwoodRipBackground";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";

export class DeadwoodRipS1Symbol extends DeadwoodRipSymbol implements IS1 {
    private _overlay:PIXI.Sprite;

    constructor(reelId:number, initState:DeadwoodRipSymbolState) {
        super("S1", reelId, initState);
        this._overlay = new PIXI.Sprite(ImgLoader.getImgTexture("S1_overlay"));
        this._overlay.anchor.set(0.5,0.5);
        this.addChild(this._overlay);
    }

    protected updateLayers():void {
        super.updateLayers();
        if (this._overlay){
            this.addChild(this._overlay);
        }
    }

    public split(type:number, noWin:boolean):TimelineLite {
        return new TimelineLite();
    }

    protected getOnShotAnimationName():string {
        return `S1_Shoot`;
    }

    protected getDeadLoopAnimationName():string {
        return "S1DeadLoop";
    }

    protected getCharacterAssetName():string {
        return "S1";
    }

    public playNormalLanding(amount:number):TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(1, "landing", false);
            DeadwoodRipSound.playS1Land(amount, this.reelId);
        });
        tl.add(() => {
            this._deadCharacter.state.setAnimation(1, "landing", false).trackTime = this._deadCharacter.spineData.findAnimation("landing").duration;
        }, `+=${this._deadCharacter.spineData.findAnimation("landing").duration}`);
        return tl;
    }

    public playNearWinLoop():void {
        this.createDeadContainer();
        this._deadCharacter.visible = true;
        this._deadCharacter.state.setAnimation(1, "attentionLoop", true);
    }

    public playWin(isLanding:boolean):TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            const entry = this._deadCharacter.state.setAnimation(1, "win", false);
            entry.timeScale = 0.5;
        });
        tl.add(() => {
            this._deadCharacter.state.setAnimation(1, "win", false).time = this._deadCharacter.spineData.findAnimation("win").duration;
        }, `+=${this._deadCharacter.spineData.findAnimation("win").duration * 2}`);

        if(isLanding) {
            const glow = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset("S1"));
            glow.autoUpdate = true;
            glow.position.set(DeadwoodRipReelView.REEL_AREAS[this.reelId].x, DeadwoodRipReelView.REEL_AREAS[this.reelId].y + DeadwoodRipSymbol.DEFAULT_HEIGHT * (DeadwoodRip.model.parsedGameData.S1Positions[this.reelId] + 0.5));
            tl.add([
                () => {
                    DeadwoodRipLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(glow);
                    glow.state.setAnimation(0, "S1Glow", false);
                    DeadwoodRipBackground.shakeStageOnce(0.3);
                }
            ], 0);
            tl.add(() => {
                DeadwoodRipLayers.getLayer(Layers.WIN_PRESENTATIONS)!.removeChild(glow);
                glow.state.setEmptyAnimations(0);
                glow.destroy();
            });
        }
        return tl;
    }

    public playWinWRSLanding(playSound:boolean):TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(1, "landing2", false);
            if(playSound) {
                DeadwoodRipSound.playS1Land(2, this.reelId);
            }
        });
        tl.add(() => {
            this._deadCharacter.state.setAnimation(1, "landing2loop", true);
        }, `+=${this._deadCharacter.spineData.findAnimation("landing2").duration}`);
        return tl;
    }

    public playTransferWRS():TimelineLite {
        this.createDeadContainer();
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            const entry = this._deadCharacter.state.setAnimation(1, "transferWRS", false);
            entry.timeScale = 0.4;
        });
        tl.add(() => {
        }, `+=${this._deadCharacter.spineData.findAnimation("transferWRS").duration * 1.5}`);
        return tl;
    }

    protected playGunShotSound(stereoIndex:number):TimelineLite {
        return DeadwoodRipSound.getDefaultGunShotBodyTimeline(stereoIndex);
    }

    protected playKillSound():void {
        DeadwoodRipSound.playSymbolKill("S", this.reelId);
    }
}